// extracted by mini-css-extract-plugin
export var container = "_gf-1";
export var cornerButtonContainer = "_gf-6";
export var disabled = "_gf-2";
export var dragActive = "_gf-3";
export var fileContainer = "_gf-5";
export var hiddenInput = "_gf-4";
export var widthContainer = "_gf-0";